export default {
  'component.notificationsent.title': 'Varsel sendt',
  'component.notificationsent.subtitle': 'Meldingen ble sendt.',
  'component.notificationsent.description':
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
    'component.notification.title': 'Melding',
};
